import { createEditorMetadata } from "./viewport";

export const extractDrawflowGraph = (state) =>
  state?.drawflow ? { drawflow: state.drawflow } : state;

export const appendEditorMetadata = (graph, viewport) => ({
  ...graph,
  _editor: createEditorMetadata(viewport),
});
